import _ from 'lodash';
import {
  LayeredRegularRelations,
  LayeredRelations,
  TextComponents,
  TextRelationStyles,
} from 'models';

export const validateTextComponents = (
  textComponents: TextComponents,
  layeredRelations: LayeredRegularRelations<TextRelationStyles>,
): { components: TextComponents; relations: LayeredRelations<TextRelationStyles> } => {
  return _.reduce(
    textComponents,
    (acc, textComponent, componentId) => {
      const componentRelations = _.pickBy(layeredRelations, relation => _.includes(relation.documentId, componentId));
      Object.assign(acc.relations, componentRelations);
      Object.assign(acc.components, textComponents);

      return acc;
    },
    {
      components: {} as TextComponents,
      relations: {} as LayeredRelations<TextRelationStyles>,
    },
  );
};

